import Footer from "../global/components/Footer";
import Header from "../global/components/Header";
import { AuthenticationProvider } from "../global/contexts/AuthenticationContext";
import { UserInfoProvider } from "../global/contexts/UserInfoContext";
import { ReportsLanding } from "./components/ReportsLanding";
import { ReportsProvider } from "./contexts/ReportsContext";

//This component sets up the Aap Reports application by calling the Header,
//AuthenticationProvider, UserInfoProvider, ReportsProvider, 
//ReportsLanding, and Footer components.
export default function AapReportsApp() {
    return (
        <>
            <Header message={"AAP Reports"} />
                <AuthenticationProvider>
                    <UserInfoProvider>
                        <ReportsProvider>
                            <ReportsLanding />
                        </ReportsProvider>
                    </UserInfoProvider>
                </AuthenticationProvider>
            <Footer />
        </>
    );
}